import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Batch, BatchStatusEnum, DeclarationCustomsFlowType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  flow: DeclarationCustomsFlowType;
}

export const useSendAllDeclarationsToIdms = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, flow }: HookProps) => {
      queryClient.setQueriesData(
        {
          queryKey: ['batches'],
        },
        (oldData: { list: Batch[]; total: number }) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            list: oldData.list.map((batch) => {
              if (batch._id === batchId) {
                return { ...batch, status: { value: BatchStatusEnum.SENDING } };
              }
              return batch;
            }),
          };
        },
      );

      await request({
        path: `idms/${batchId}/send-all-declarations`,
        method: 'POST',
        authenticate: true,
        dataObject: { flow },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.batchId] });
      toast.success('Started sending all declarations!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error sending all declarations!');
    },
  });
};
